import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TextBox from "../../components/TextBox";
import DatePickV2 from "../../components/DatePickV2";
import ButtonSubmit from "../../components/ButtonSubmit";
import { Add } from "@mui/icons-material";
import TextCurrency from "../../components/TextCurrency";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import CustomSwitch from "../../components/CustomSwitch";
import { SettlementsAPI } from "../../services/api";
import CustomSnackBar from "../../components/CustomSnackBar";

export default function ReceiptForm({ setOpen, onSave, initialData }) {
  const [form, setForm] = useState({
    number: '',
    date: new Date(),
    amount: 0,
    rType: 'electronico',
    is_ph: true,
  });
  const [numErr, setNumErr] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [snack, setSnack] = useState({ open: false, message: '', severity: 'info' });

  useEffect(() => {
    if (initialData) {
      setForm({
        number: initialData.number || '',
        date: initialData.date || new Date(),
        amount: Number(initialData.amount || 0),
        rType: initialData.rType || 'electronico',
        is_ph: typeof initialData.is_ph === 'boolean' ? initialData.is_ph : true,
      });
    }
  }, [initialData]);

  const handleChange = (name, value) => setForm((p) => ({ ...p, [name]: value }));

  // Valida contra el backend: 200 OK = libre, 409 = duplicado
  const validateNumber = async (val) => {
    const num = String(val ?? form.number ?? '').trim();
    if (!num) { setNumErr(''); return true; }

    try {
      await SettlementsAPI.checkReceipt(num);
      setNumErr('');
      return true;
    } catch (e) {
      if (e?.response?.status === 409) {
        const msg = 'Error por recibo duplicado: ese número ya existe.';
        setNumErr(msg);
        setSnack({ open: true, message: msg, severity: 'error' });
      } else {
        const msg = 'No se pudo validar el número de recibo. Intenta de nuevo.';
        setNumErr(msg);
        setSnack({ open: true, message: msg, severity: 'error' });
      }
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (submitting) return;
    setSubmitting(true);
    try {
      // 1) Validar duplicado
      const okNum = await validateNumber(form.number);
      if (!okNum) return;

      // 2) Validar monto
      const amountNum = Number(form.amount) || 0;
      if (amountNum <= 0) {
        setSnack({ open: true, message: 'El monto debe ser mayor a 0.', severity: 'error' });
        return;
      }

      onSave({
        number: String(form.number || '').trim(),
        date: form.date,
        amount: amountNum,
        rType: form.rType,
        is_ph: !!form.is_ph,
      });
      setOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 380, m: '0 auto' }}>
      <TextBox
        label="No. recibo"
        name="number"
        onChange={handleChange}
        width={'300px'}
        newValue={form.number}
        // Si aplicas el parche A en TextBox, esto valida al salir del input:
        onBlur={() => validateNumber(form.number)}
        // y muestra error externo directamente en el TextField:
        externalErrorText={numErr}
      />
      {/* si no aplicas el parche A, deja la línea de abajo como fallback visual */}
      {/* {!!numErr && <Typography variant='caption' color='error'>{numErr}</Typography>} */}

      <TextCurrency
        label="Monto"
        name="amount"
        onChange={handleChange}
        newValue={form.amount}
        matchTextBox
        width={'300px'}
      />

      <FormControl fullWidth size="small" sx={{ width: '300px', mt: 2 }}>
        <InputLabel id="rtype-label">Tipo</InputLabel>
        <Select
          labelId="rtype-label"
          label="Tipo"
          value={form.rType}
          onChange={(e) => handleChange('rType', e.target.value)}
        >
          <MenuItem value="electronico">Electrónico</MenuItem>
          <MenuItem value="manual">Manual</MenuItem>
        </Select>
      </FormControl>

      <DatePickV2
        name="date"
        label="Fecha"
        value={form.date}
        onChange={handleChange}
        width={'300px'}
        size={'small'}
        allowFutureDates={true}
        allowHistoricalDates={true}
      />

      <Box sx={{ width: '300px', mt: 1, display: 'flex', justifyContent: 'center' }}>
        <CustomSwitch
          name="is_ph"
          label={form.is_ph ? "Físico" : "No físico"}
          onChange={(name, value) => setForm((prev) => ({ ...prev, [name]: value }))}
          initialValue={!!form.is_ph}
        />
      </Box>

      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 1 }}>
        <ButtonSubmit name={submitting ? 'Validando...' : 'Agregar'} icon={Add} loading={submitting} />
      </Box>

      <CustomSnackBar
        open={snack.open}
        setOpen={(val) => setSnack(prev => ({ ...prev, open: val }))}
        message={snack.message}
        severity={snack.severity}
      />
    </Box>
  );
}
